import ActionTypes from '../../../../../../ActionsTypes';
export function toggleDropdown(countryID, plotID, id) {
  return {
    type: ActionTypes.TOGGLE_ITEMS,
    payload: {
      countryID: countryID,
      plotID: plotID,
      id: id
    }
  };
}